import React, { Component } from 'react';

export default class PageFooter extends Component{
  render() {
    let years = new Date().getFullYear();
    return (
      <div className="page-footer">
        <div className="row">
          <div className="col-xs-12">
            <span className="txt-color-white">
              {`International SOS Email Alert Subscription Platform @ 2016 - ${years}`}
            </span>
            <span className="powered-by">
              Powered by <a href="https://oxone.io" target="_blank">Oxone.io</a>
            </span>
          </div>

          {/*<div className="col-xs-6 col-sm-6 text-right hidden-xs">*/}
            {/*<div className="txt-color-white inline-block">*/}
              {/*##                        <i className="txt-color-blueLight hidden-mobile">Last account activity <i className="fa fa-clock-o" />*/}
              {/*##                            <strong>52 mins ago &nbsp;</strong> </i>*/}
            {/*</div>*/}
          {/*</div>*/}
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/component/dashboard/pageFooter.js